import { useRouter } from 'next/router';
import NextNProgress from 'nextjs-progressbar';

/**
 * The navigation progress bar, and the one rule it has: **it must never unmount.**
 *
 * `nextjs-progressbar` registers `routeChangeStart` / `routeChangeComplete` / `routeChangeError`
 * in a `useEffect` with an empty dependency array, and its cleanup calls `Router.events.off` on
 * all three. nprogress itself is a module-level singleton living on `document.body`, so whoever
 * called `start()` is not necessarily the one who gets to call `done()`, and nothing reconciles
 * the two. Unmount this component between a start and its completion and the bar is stranded:
 * it trickles to ~90% and stays there until the next navigation happens to restart it.
 *
 * Suppressing a route by returning `null` from a wrapper — which is what `GuardLoaderComponent`
 * did here — is exactly that unmount, so every navigation *into* one of the routes below could
 * strand the bar. worker-app had the same defect in a worse position (the bar was inside
 * `AuthGuard`, which swaps its children for a loader during a login hand-over) and that is the
 * one that was reported, on `/candidature/[id]/intervista` opened from an e-mail link.
 *
 * ## Suppression is visual, and deliberately not an unmount
 *
 * `nprogress.css` is never imported anywhere in this repo, so the only styling the bar has is
 * the `<style>` tag this component renders. Rendering none hides it in exactly the same way the
 * old wrapper did, while leaving the listeners attached — which is the point.
 */
const HIDDEN_PATHS = ['/employer/job-positions/onboarding', '/getting-started'];

export const ProgressBar = () => {
  const { pathname } = useRouter();

  return (
    <NextNProgress
      color={'#8e69ce'}
      showOnShallow
      options={{ showSpinner: false }}
      transformCSS={(css) => (HIDDEN_PATHS.includes(pathname) ? <></> : <style>{css}</style>)}
    />
  );
};

export default ProgressBar;
